import React from 'react';
import { BASE_URL } from "../lib/apiClient"

const AccountantLogo: React.FC<{style: React.CSSProperties}> = ({ style }) => <img alt="Accountant Logo" style={style} src={BASE_URL+'/assets/logo-full.png'}></img>;

export default AccountantLogo;